import { defineMessages } from "react-intl";

export const messages = defineMessages({
  stepperTitle: {
    id: "publicGisOrderLookup.stepperTitle",
    defaultMessage: "Enter your information to continue as guest",
  },
  stepperSubtitle: {
    id: "publicGisOrderLookup.stepperSubtitle",
    defaultMessage:
      "Quick, simple sign-up. Manage results, appointments, and bills in one place.",
  },
  portalHeading: {
    id: "publicGisOrderLookup.portalHeading",
    defaultMessage: "Natera's Patient Portal",
  },
  nameStepTitle: {
    id: "publicGisOrderLookup.nameStepTitle",
    defaultMessage: "What is your name?",
  },
  dobStepTitle: {
    id: "publicGisOrderLookup.dobStepTitle",
    defaultMessage: "What is your date of birth?",
  },
  contactStepTitle: {
    id: "publicGisOrderLookup.contactStepTitle",
    defaultMessage: "How can we reach you?",
  },
  confirmStepTitle: {
    id: "publicGisOrderLookup.confirmStepTitle",
    defaultMessage: "Confirm your details",
  },
  firstName: {
    id: "publicGisOrderLookup.firstName",
    defaultMessage: "First Name",
  },
  lastName: {
    id: "publicGisOrderLookup.lastName",
    defaultMessage: "Last Name",
  },
  dateOfBirth: {
    id: "publicGisOrderLookup.dateOfBirth",
    defaultMessage: "Date of Birth",
  },
  oneOfFollowing: {
    id: "publicGisOrderLookup.oneOfFollowing",
    defaultMessage: "Please enter one of the following information:",
  },
  zipCode: {
    id: "publicGisOrderLookup.zipCode",
    defaultMessage: "Zip code",
  },
  mobileNumber: {
    id: "publicGisOrderLookup.mobileNumber",
    defaultMessage: "Mobile number",
  },
  email: {
    id: "publicGisOrderLookup.email",
    defaultMessage: "Email",
  },
  back: {
    id: "publicGisOrderLookup.back",
    defaultMessage: "Back",
  },
  continue: {
    id: "publicGisOrderLookup.continue",
    defaultMessage: "Continue",
  },
  fieldRequired: {
    id: "publicGisOrderLookup.fieldRequired",
    defaultMessage: "Please fill in this field.",
  },
  nameTooLong: {
    id: "publicGisOrderLookup.nameTooLong",
    defaultMessage: "Please enter no more than {maxLength} characters.",
  },
  invalidDateOfBirth: {
    id: "publicGisOrderLookup.invalidDateOfBirth",
    defaultMessage: "Please enter a valid date of birth.",
  },
  under18DateOfBirth: {
    id: "publicGisOrderLookup.under18DateOfBirth",
    defaultMessage:
      "The patient portal does not currently have test information for patients under 18 years old. Please reach out to your provider, or contact support@natera.com, for information on tests for patients under 18.",
  },
  invalidEmail: {
    id: "publicGisOrderLookup.invalidEmail",
    defaultMessage: "Please enter a valid email address.",
  },
  invalidMobileNumber: {
    id: "publicGisOrderLookup.invalidMobileNumber",
    defaultMessage:
      "Please enter a valid mobile number with the country code, like +1-555-123-4567.",
  },
  invalidZipCode: {
    id: "publicGisOrderLookup.invalidZipCode",
    defaultMessage: "Please enter a valid zip code.",
  },
  recaptchaRequired: {
    id: "publicGisOrderLookup.recaptchaRequired",
    defaultMessage: "Please complete the reCAPTCHA.",
  },
  recaptchaExpired: {
    id: "publicGisOrderLookup.recaptchaExpired",
    defaultMessage:
      "Your verification timed out. Please check the box above again.",
  },
  recaptchaErrored: {
    id: "publicGisOrderLookup.recaptchaErrored",
    defaultMessage:
      "We couldn't complete the verification. Please check the box above again.",
  },
  submit: {
    id: "publicGisOrderLookup.submit",
    defaultMessage: "Find my order",
  },
  matching: {
    id: "publicGisOrderLookup.matching",
    defaultMessage: "Looking for your order...",
  },
  errorNoPatientTitle: {
    id: "publicGisOrderLookup.errorNoPatientTitle",
    defaultMessage: "We couldn't find a matching record",
  },
  errorNoPatientBody: {
    id: "publicGisOrderLookup.errorNoPatientBody",
    defaultMessage:
      "We couldn't match the details you entered to a patient on file. Please double-check your information and try again.",
  },
  errorNoOrderTitle: {
    id: "publicGisOrderLookup.errorNoOrderTitle",
    defaultMessage: "No eligible order found",
  },
  errorNoOrderBody: {
    id: "publicGisOrderLookup.errorNoOrderBody",
    defaultMessage:
      "We found your record but couldn't find a test order eligible for a Genetic Information Session.",
  },
  errorMultipleTitle: {
    id: "publicGisOrderLookup.errorMultipleTitle",
    defaultMessage: "We need a little more help",
  },
  errorMultipleBody: {
    id: "publicGisOrderLookup.errorMultipleBody",
    defaultMessage:
      "We found more than one order for you. Please contact us so we can help you schedule your session.",
  },
  errorApptExistsTitle: {
    id: "publicGisOrderLookup.errorApptExistsTitle",
    defaultMessage: "You already have a session scheduled",
  },
  errorApptExistsBody: {
    id: "publicGisOrderLookup.errorApptExistsBody",
    defaultMessage:
      "Our records show you already have a Genetic Information Session scheduled.",
  },
  errorGenericTitle: {
    id: "publicGisOrderLookup.errorGenericTitle",
    defaultMessage: "Something went wrong",
  },
  errorGenericBody: {
    id: "publicGisOrderLookup.errorGenericBody",
    defaultMessage:
      "We ran into a problem looking for your order. Please try again in a few minutes.",
  },
  tryAgain: {
    id: "publicGisOrderLookup.tryAgain",
    defaultMessage: "Try again",
  },
  scheduleTitle: {
    id: "publicGisOrderLookup.scheduleTitle",
    defaultMessage: "Schedule your Genetic Information Session",
  },
});
